import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GRID_LAYOUT_STORE_NAME } from './consts';
import {
  IGridLayoutState,
  IStateWithGridLayout,
  IEditGridModel,
  IEditPanelsListModel,
} from './models';

const initialState: IGridLayoutState = {
  isPanelResetting: {},
  isEditModeOn: {},
  currentBreakpoint: 'lg',
  visiblePanelsList: {},
  isLoading: false,
};

const gridLayoutStore = createSlice({
  name: GRID_LAYOUT_STORE_NAME,
  initialState,
  reducers: {
    resetPanels: (state, { payload }: PayloadAction<IEditGridModel>) => {
      state.isPanelResetting = {
        ...state.isPanelResetting,
        [payload.name]: payload.value,
      };
    },
    setIsEditModeOn: (state, { payload }: PayloadAction<IEditGridModel>) => {
      state.isEditModeOn = {
        ...state.isEditModeOn,
        [payload.name]: payload.value,
      };
    },
    setVisiblePanelsList: (
      state,
      { payload }: PayloadAction<IEditPanelsListModel>
    ) => {
      state.visiblePanelsList = {
        ...state.visiblePanelsList,
        [payload.name]: payload.value,
      };
    },
    setCurrentBreakpoint: (state, { payload }: PayloadAction<string>) => {
      state.currentBreakpoint = payload;
    },
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
  },
});

export const gridLayoutActions = {
  ...gridLayoutStore.actions,
};

export const gridLayoutReducer = gridLayoutStore.reducer;

export const getIsPanelResetting = (state: IStateWithGridLayout, storageName) =>
  state[GRID_LAYOUT_STORE_NAME].isPanelResetting[storageName] || false;

export const getIsEditModeOn = (state: IStateWithGridLayout, storageName) =>
  state[GRID_LAYOUT_STORE_NAME].isEditModeOn[storageName] || false;

export const getCurrentBreakpoint = (state: IStateWithGridLayout) =>
  state[GRID_LAYOUT_STORE_NAME].currentBreakpoint;

export const getVisiblePanelsList = (
  state: IStateWithGridLayout,
  storageName
) => state[GRID_LAYOUT_STORE_NAME].visiblePanelsList[storageName];

export const getIsLoading = (state: IStateWithGridLayout) =>
  state[GRID_LAYOUT_STORE_NAME].isLoading;
